import moment from 'moment';

export default {
    data() {
        return {
            userData: null,
            step: 1,
            steps: [
                { number: 1, name: 'intro' }
            ],
            collections: {
                gender: [],
                jobLevels: [],
                jobIndustries: [],
                countries: [],
            },

            profile: {},
            inputs: ['lastName', 'dateOfBirth', 'postalCode'],
            selects: ['genderId', 'jobLevelId', 'jobIndustryId'],
            autocompletes: ['countryId'],
            phoneRegEx: /^\(?([0-9]{3})\)?([0-9]{3})\)?([0-9]{4})$/,
            rules: {
                lastName: [v => (v && v.length <= 50) || 'Name must be less than 50 characters'],
                dateOfBirth: [v => (v && moment(v, 'MM/DD/YYYY', true).isValid()) || 'Date must be in \'MM/DD/YYYY\' format.'],
                postalCode: [v => (v && v.length <= 10) || 'Postal code must less than 10 characters'],
            },

            message: null,
            messageClass: null,
            messageTimer: null,
            codeError: '',
            toggleDetails: false,
            showBanner: true
        }
    },
    computed: {
        helperText() {
            let text = this.$helperTextService.getText(this.steps[this.step - 1].name);
            return text.replace('<first name>', this.profile.firstName);
        }

    },
    filters: {
        fieldName(value) {
            var caps = value.match(/[A-Z]/g);
            caps.forEach(function (char) {
                value = value.replace(char, ' ' + char.toLowerCase());
            });

            if (value.indexOf('id') > -1) {
                value = value.replace(' id', '');
            }

            return value;
        }
    },
    watch: {
        steps(val) {
            if (this.step > val) {
                this.step = val
            }
        },
        profile(val) {
            let stepIndex = this.steps.length;

            if (stepIndex === 1) {

                for (const property in val) {
                    if (val[property] === null) this.steps.push({ 'number': ++stepIndex, 'name': property });
                    var caps = property.match(/[A-Z]/g);
                    let readable = property;
                    caps.forEach(function (char) {
                        let lowerChar = ' ' + char.toLowerCase();
                        readable = readable.replace(char, lowerChar);
                    });
                }
            }
        },
    },
    mounted() {
        this.loadUserData();
    },
    methods: {
        async loadUserData() {
            let self = this;

            await this.$authManager.getUser(function (user) {
                self.userData = user;
                self.$api.getUser(user).then(function (result) {
                    self.profile = {
                        firstName: result.firstName,
                        lastName: result.lastName,
                        dateOfBirth: result.dateOfBirth ? moment(String(result.dateOfBirth)).format('MM/DD/YYYY') : null,
                        genderId: result.genderId,
                        postalCode: result.postalCode,
                        countryId: result.countryId,
                        jobLevelId: result.jobLevelId,
                        jobIndustryId: result.jobIndustryId,
                    };
                });

                self.$api.getCountries(user).then(function (response) {
                    self.collections.countries = response;
                });

                self.$api.getGlobalTypesByName(user, 'gender').then(function (response) {
                    self.collections.genders = response;
                });

                self.$api.getGlobalTypesByName(user, 'joblevel').then(function (response) {
                    self.collections.jobLevels = response;
                });

                self.$api.getGlobalTypesByName(user, 'jobindustry').then(function (response) {
                    self.collections.jobIndustries = response;
                });

                self.$state.set('loading', false);
            });
        },
        customFilter(item, queryText) {
            const textOne = item.name.toLowerCase()
            const textTwo = item.code.toLowerCase()
            const searchText = queryText.toLowerCase()

            return textOne.indexOf(searchText) > -1 ||
                textTwo.indexOf(searchText) > -1
        },
        setProperty(item) {
            
            let self = this,
                isLast = item.number === self.steps.length,
                data = {
                    id: self.userData.profile.sub,
                    name: item.name,
                    value: self.profile[item.name],
                    isLast: isLast
                };

            if ((data.value && data.value != '') || isLast) {
                this.$state.set("loading", true);
                self.$api.setProperty(self.userData, data, function (response) {
                    let message = response.status != 200 &&
                        response.data ?
                        response.data.value : null;
                    self.$state.set("loading", false);
                    self.showMessage(message || 'Failed to save your response', 'error-message');
                }).then(function (responseData) {
                    if (responseData) {
                        self.$state.set("loading", false);

                        if (isLast) {
                            localStorage.setItem('showWelcome-' + self.userData.profile.sub, false);
                            self.$state.set("welcome", false);
                            self.$router.replace('/');
                        } else {
                            self.step = item.number + 1;
                        }
                    }
                });
            } else {
                self.step = item.number + 1;
            }

        },
        nextStep(item) {
            this.toggleDetails = false;
            if (item.name === 'intro') {
                this.step = item.number + 1;
            } else {
                this.setProperty(item);
            }
        },
        skipStep(item) {
            this.profile[item.name] = null;

            this.nextStep(item);
        },
        getHelperText(propertyName) {
            let text = this.$helperTextService.getText(propertyName);
            return text.replace('<first name>', this.profile.firstName);
        },
        toggleHelper() {
            this.toggleDetails = !this.toggleDetails;
            if(this.showBanner) {
                this.showBanner = false;
            }
        },
        showMessage(message, messageClass) {
            let self = this;

            self.message = message;
            self.messageClass = messageClass;

            clearTimeout(self.messageTimer);
            self.messageTimer = setTimeout(function () {
                self.clearMessage(messageClass);
            }, 3000);
        },
        clearMessage(messageClass) {
            let self = this;

            self.messageClass = messageClass + ' fade-out';

            clearTimeout(self.messageTimer);
            self.messageTimer = setTimeout(function () {
                self.message = null;
                self.messageClass = null;
            }, 700);

        }
    },
}